module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contactData.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-section"
  }, _vm._l((_vm.contactData.contacts), function(contact) {
    return _c('div', {
      staticClass: "contact-item"
    }, [_c('h3', [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": contact.logo
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": contact.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(contact.text))])]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "qr",
      attrs: {
        "src": contact.qr
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca54fd1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 386
// module chunks = 1